module.exports = __webpack_public_path__ + "static/media/home-page-image-small.ca00e87c.jpg";